
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
    data () {
        return {
            limitedCollection: [],
            sorting: null,
        }
    },
    computed: {
        ...mapGetters({
            completedCourses: 'CompletedCourses/certificates',
            coursesForVideoLogs: 'VideoLog/getCoursesForVideoLogs',
            user: 'User/getCurrentUser',
            signedUpEvents: 'Courses/getSignedUpEventsForUser',
        }),
        uncompletedCourses () {
            let uncompletedVideoCourses = this.coursesForVideoLogs.filter((course) => {
                return this.completedCourses.courses.findIndex(el => el.id === course.id) === -1
            })
            let uncompletedDigitalClassRoomCourses = this.signedUpEvents
                .filter(event => {
                    const isCompleted = this.completedCourses.courses.some(course => course.id === event.training.course.id)
                    return !isCompleted
                })
                .filter(event => {
                    const isOk = event.subscriptionStatus === 'ok'
                    const isPastSession = moment().unix() > moment(event.training.sessions[0].endDateAndTime).unix()
                    return isOk && isPastSession
                })
                .map(event => {
                    event.training.course.lastActivityDateAndTime = event.training.sessions[0].endDateAndTime
                    return event.training.course
                })
            const uncompletedCourses = [...uncompletedDigitalClassRoomCourses, ...uncompletedVideoCourses]
            return uncompletedCourses
        },
    },
    methods: {
        onCourseListChange (newCourseList) {
            this.limitedCollection = newCourseList
        },
        sortingChange (sortBy) {
            this.sorting = sortBy
        }
    },
    async created () {
        await this.$store.dispatch('VideoLog/loadCoursesForVideolog')
        await this.$store.dispatch('Courses/loadSignedUpEvents')
    }
}
